import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "koutu-member-center" }
const _hoisted_2 = { class: "wrapper_scroll hg_690" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "koutu_title" }, " 智能抠图，按张购买，永久有效！ ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_Pay = _resolveComponent("Pay")!
  const _component_Interests = _resolveComponent("Interests")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_UserInfo, { "fixed-height": true }, {
      default: _withCtx(() => [
        _createVNode(_component_Header)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Pay),
      _createVNode(_component_Interests)
    ])
  ]))
}